import { ActionTree } from 'vuex';
import { AppState } from './state';
import { SET_LANG } from './mutations';
import { loadLanguageAsync } from '@/locales';
import { sourceStore } from '@/utils/local-storage';
import { STORAGE_LANG_KEY } from '@/store/mutation-type';
import { RootState } from '@/store/root-state';

export const actions: ActionTree<AppState, RootState> = {
  [SET_LANG]({ commit }, lang: string) {
    return new Promise<void>((resolve, reject) => {
      loadLanguageAsync(lang)
        .then(() => {
          commit(SET_LANG, lang);
          sourceStore.set(STORAGE_LANG_KEY, lang);
          resolve();
        })
        .catch((e: Error) => {
          reject(e);
        });
    });
  },
};
